import _ from 'lodash';
// patch in these functions
_.contains = (src: string, what: string) => {
  if (!src || !src.indexOf) { return false; }

  return src.indexOf(what) !== -1;
};
_.trimLeft = (string: string) => string.replace(/^\s+/, '');
